import R from 'ramda'

const FACEBOOK_COMMENT_WIDGET_TYPE = 'SEND_FACEBOOK_COMMENT'
const FACEBOOK_COMMENT_DISPLAY_TYPE = 'Send Facebook Comment'

const isFacebookCommentWidgetAction = R.propEq(
  'type',
  FACEBOOK_COMMENT_WIDGET_TYPE
)

const convertFacebookCommentWidgetActionToFormAction = R.applySpec({
  type: R.always(FACEBOOK_COMMENT_DISPLAY_TYPE),
  message: R.path(['message', 'message']),
  attachmentUrl: R.path(['message', 'attachment_url']),
  attachmentShareUrl: R.path(['message', 'attachment_share_url'])
})

export {
  isFacebookCommentWidgetAction,
  convertFacebookCommentWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-comment.js